import React from 'react'
import { Helmet } from 'react-helmet'

const SeoSales = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title + ' | Gemvision'}</title>
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <link rel='canonical' href='https://gemvision.com/sales' />
      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "Contact Sales",
            "description": "Get all the commercial assistance you need from our experts serving your location.",
            "item": "https://gemvision.com/sales"  
          }]
        }`}
      </script>
    </Helmet>
  )
}

export default SeoSales
